"use client";
import { missingTranslationsDetector } from "@/utils/missingTranslationsDetector";
import { useTranslations } from "next-intl";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useTranslationDetector = (namespace) => {
  const t = useTranslations(namespace);

  return t;

  /*
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const allowLocalizationDomain =
    typeof window === "undefined"
      ? false
      : [
          "http://localhost:3000",
          "https://stage.turna.com",
          "https://test.turna.com",
          "https://cce-saka-test.turna.com",
        ].includes(window.location.origin);

  const wrappedT = useCallback(
    (key, values) => {
      if (typeof window === "undefined" || !allowLocalizationDomain) {
        try {
          if (values && typeof values === "object" && !isMounted) {
            return key;
          }
          return t(key, values);
        } catch (error) {
          return key;
        }
      }

      try {
        const result = t(key, values);
        const fullKey = namespace ? `${namespace}.${key}` : key;

        if (
          result === key ||
          result === fullKey ||
          result === undefined ||
          result === ""
        ) {
          missingTranslationsDetector.missingKeys.add({
            key: fullKey,
            locale: "current",
            type: "missing",
          });
        }

        return result;
      } catch (error) {
        const fullKey = namespace ? `${namespace}.${key}` : key;
        missingTranslationsDetector.missingKeys.add({
          key: fullKey,
          locale: "current",
          type: "missing",
        });
        return key;
      }
    },
    [t, namespace, isMounted],
  );

  const proxiedT = useMemo(() => {
    return new Proxy(wrappedT, {
      get(target, prop) {
        if (prop === "raw" || prop === "rich") {
          const originalMethod = t[prop];

          if (typeof originalMethod !== "function") {
            return originalMethod;
          }

          return (key, ...args) => {
            if (typeof window === "undefined" || !allowLocalizationDomain) {
              try {
                return originalMethod(key, ...args);
              } catch (error) {
                return key;
              }
            }

            try {
              const result = originalMethod(key, ...args);
              const fullKey = namespace ? `${namespace}.${key}` : key;

              if (
                result === key ||
                result === fullKey ||
                result === undefined ||
                result === ""
              ) {
                missingTranslationsDetector.missingKeys.add({
                  key: fullKey,
                  locale: "current",
                  type: "missing",
                });
              }

              return result;
            } catch (error) {
              const fullKey = namespace ? `${namespace}.${key}` : key;
              missingTranslationsDetector.missingKeys.add({
                key: fullKey,
                locale: "current",
                type: "missing",
              });
              return key;
            }
          };
        }

        if (typeof prop === "string") {
          const key = namespace ? `${namespace}.${prop}` : prop;

          if (typeof window === "undefined" || !allowLocalizationDomain) {
            try {
              return t[prop];
            } catch (error) {
              return prop;
            }
          }

          try {
            const result = t[prop];

            if (
              result === prop ||
              result === key ||
              result === undefined ||
              result === ""
            ) {
              missingTranslationsDetector.missingKeys.add({
                key,
                locale: "current",
                type: "missing",
              });
            }

            return result;
          } catch (error) {
            missingTranslationsDetector.missingKeys.add({
              key,
              locale: "current",
              type: "missing",
            });
            return prop;
          }
        }
        return target[prop];
      },
    });
  }, [wrappedT, t, namespace, allowLocalizationDomain]);

  return proxiedT;

  */
 
};
